import { Link } from 'react-router-dom';

import './page-404.scss';

import { routerKeys } from '~shared/router';

export function Page404() {
	return (
		<div className="page-404">
			<div className="container">
				<h1 className="logo-font">Page not found</h1>
				<p>Sorry, we couldn&apos;t find the page you&apos;re looking for.</p>
				<Link to={routerKeys.root()} className="btn btn-sm btn-outline-primary">
					Go back home
				</Link>
			</div>
		</div>
	);
}
